export const PROJECT_USERS_PER_PAGE = 100;
export const ORDER_BY_NAME = 'NAME';
export const USER_ACTIVE_STATUS = 'ACTIVE';
export const USER_DELETED_STATUS = 'DELETED';
export const USER_INVITED_STATUS = 'INVITED';
export const USER_ASSIGNED_STATUS = 'ASSIGNED';
